/*eslint-disable*/
import React, { useEffect, useState } from "react";
import ProfileBanner from "../Components/CompanyProfile/ProfileBanner";
import ProfileDetail2 from "../Components/CompanyProfile/ProfileDetail2";
import { useParams } from "react-router-dom";
import { api_url } from "../Constants/web_services";
// import NoData from "../Components/SearchList/NoData";
import Loading from "../Components/SearchList/Loading";

const CompanyProfile = () => {
  const { id } = useParams();
  const [companyData, setCompanyData] = useState(null);

  const fetchData = () => {
    // Define the API URL based on the ID parameter
    const apiUrl = api_url + `/api/company/${id}`;

    // Make an HTTP GET request to fetch the company data
    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Handle the successful response and update the state with the data
        setCompanyData(data.data.companyProfile);
        //   console.log(data.data.companyProfile, "data");
      })
      .catch((error) => {
        // Handle errors if any
        console.error("Error fetching company data:", error);
      });
  };

  useEffect(() => {
    fetchData();

    const timer = setInterval(() => {
      fetchData();
      // alert("Fetching data every 2 minutes!"); // Display an alert every 2 minutes
    }, 2 * 60 * 1000); // 2 minutes in milliseconds

    return () => clearInterval(timer);
  }, [id]);



  // Render a loading message while data is being fetched
  if (!companyData) {
    return <Loading />;
  }
  // console.log(companyData.data.companyProfile.name,"detail")
  return (
    <>
      {/* <ProfileBanner companyData={companyData} /> */}
      <ProfileDetail2 companyData={companyData} />
    </>
  );
};

export default CompanyProfile;
